import React, {useEffect} from 'react';
import $ from "jquery";
import {GET_COL_AGGREGATE_DATA} from "../../api";
import cogoToast from "cogo-toast";
import {capitalize} from "../../utils/capitalize";
import moment from "moment";
import {assignment, task} from "../../api/app";

let type = null;

let currDateRange = null;
let filter = {};

const DTTask = ({id}) => {
    const token = localStorage.getItem('jwtToken');

    useEffect(() => {

        filter = {
            assignment: id
        };

        let table = $('#task-table').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Task Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "tasks",
                        filter: [
                            { $match: filter },
                            {
                                $lookup: {
                                    from: "users",
                                    localField: "user",
                                    foreignField: "_id",
                                    as: "user"
                                }
                            },
                            { $unwind: "$user" },
                            {
                                $lookup: {
                                    from: "submissions",
                                    let: { taskId: "$_id", userId: "$user._id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: { $eq: ["$task", "$$taskId"] },
                                            }
                                        }
                                    ],
                                    as: "submissions"
                                }
                            },
                            {
                                $addFields: {
                                    submitted: {
                                        $gt: [
                                            { $size: { $ifNull: ["$submissions", []] } },
                                            0
                                        ]
                                    }
                                }
                            },
                            {
                                $project: {
                                    _id: 0,
                                    task_id: "$_id",
                                    description: 1,
                                    status: 1,
                                    date: "$date.iso",
                                    user_name: "$user.name",
                                    user_id: "$user._id",
                                    mobile_number: "$user.mobile_number",
                                    submissions: 1,
                                    submitted: 1
                                }
                            },
                            { $sort: { date: -1 } },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/user/${data?.user_id}" class="nav-label tx-color-01" target="_blank"> ${capitalize(data?.user_name || "User not found")}</a></nav>`
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.mobile_number;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            'awaiting' : `<span class="badge badge-primary tx-white">Awaiting</span>`,
                            'pending' : `<span class="badge badge-warning tx-white">Pending</span>`,
                            'completed' : `<span class="badge badge-success tx-white">Completed</span>`,
                            'rejected' : `<span class="badge badge-danger tx-white">Rejected</span>`
                        }[data.status];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date).format("Do MMM, YYYY")
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `${data.status === "awaiting" ? `<nav class="nav nav-icon-only"><a href="#" class="nav-link approve"><i class="fa fa-check"></i> Approve</a> <a href="#" class="nav-link reject"><i class="fa fa-ban"></i> Reject</a></nav>` : `<nav class="nav nav-icon-only"><span href="#" class="nav-link"><i class="fa fa-ban"></i> No Action</span></nav>`}`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.approve', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            let id = extract_td?.raw?.task_id;

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            let data = {
                id,
                action: "completed"
            }

            task("put", data).then((result) => {
                hide();
                if(!result.error) {
                    reloadTable();
                    cogoToast.success("Task successfully approved.", {position: "top-right"});
                }
            });
        });

        $('#task-table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            if(d?.raw?.submitted) {
                return (
                    '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td>Task:</td>' +
                    '<td>' +
                    d?.raw?.description +
                    '</td>'+
                    '</tr>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>Link:</td>' +
                    '<td>' +
                    '<a href='+d?.raw?.submissions[0]?.url+' target="_blank">'+ "View Link" + '</a>' +
                    '</td>'+
                    '</tr>' +
                    '</tr>' +
                    '</table>'
                );
            }

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d?.raw?.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
            type = null;
            filter = {};
            currDateRange = null;
        }

    }, [id]);

    const reloadTable = () => {
        $('#task-table').DataTable().ajax.reload(null, false);
    };

    const handleFilterSelect = (value) => {
        filter = Object.assign(filter, {
            "status": value
        });

        $("#tx-filter-level").text(value);
        reloadTable();
    };

    return (
        <div>
            <div className="d-flex tx-18 mg-b-20 justify-content-between">
                <div className="d-flex">
                    {/*<div className="dropdown">*/}
                    {/*    <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-support-level">Select Date</span></a>*/}
                    {/*    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">*/}
                    {/*        {past_date.map((item, index) => (*/}
                    {/*            <a className="dropdown-item" href="javascript:void(0)" key={index} onClick={handleDateSelect.bind(null, item.value, item.name)}>{item.name}</a>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="dropdown">
                        <a href="javascript:void(0)" className="tx-13 link-03 pd-0-f outline-none dropdown-toggle" id="dropdownSelectButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span className="text-capitalize" id="tx-filter-level">Filter By</span></a>
                        <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">
                            {/*<a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "all")}>All</a>*/}
                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "awaiting")}>Awaiting</a>
                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "pending")}>Pending</a>
                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "completed")}>Completed</a>
                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "rejected")}>Rejected</a>
                        </div>
                    </div>
                </div>
                {/*{exportLoading ? <button disabled className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/> Exporting</button> : <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" onClick={exportData.bind()}><i className="wd-10 mg-r-5 fa fa-upload"></i> Export</button>}*/}
            </div>
            <table id="task-table" className="table" style={{ width: "100%" }}>
                <thead>
                <tr>
                    <th></th>
                    <th className="wd-20p">Name</th>
                    <th className="wd-20p">Mobile Number</th>
                    <th className="wd-20p">Status</th>
                    <th className="wd-20p">Date</th>
                    <th className="wd-20p">Actions</th>
                </tr>
                </thead>
            </table>
        </div>
    );
};

export default DTTask;
